// HEADER HIDE ON SCROLL DOWN / SHOW ON SCROLL UP
const headerComponent = document.querySelector('.c-header-component');
const header = document.querySelector('.c-header');
let lastScrollY = window.scrollY;
let hasHidden = false;

headerComponent.style.transition = 'transform .4s cubic-bezier(.165, .84, .44, 1)';

window.addEventListener('scroll', () => {
  const currentScrollY = window.scrollY;
  const scrollingDown = currentScrollY > lastScrollY;

  if (scrollingDown && currentScrollY > 100) {
    // Scroll down — slide header out of view
    headerComponent.style.transform = 'translateY(-100%)';
    if (!hasHidden) {
      // Add scrolled class after the slide-out transition completes on first hide
      headerComponent.addEventListener('transitionend', () => {
        header.classList.add('scrolled');
      }, { once: true });
      hasHidden = true;
    }
  } else if (!scrollingDown) {
    // Scroll up — slide header back into view
    headerComponent.style.transform = 'translateY(0)';
    // Remove scrolled class when back at the top
    if (currentScrollY <= 100) {
      hasHidden = false;
      header.classList.remove('scrolled');
    }
  }

  lastScrollY = currentScrollY;
});